import styled from 'styled-components';

export const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  margin: 0 auto 16px;
  width: 70%;
  border-radius: 8px;
  background: ${({ theme }) => theme.toast.warning.background};
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
`;

export const BannerMessage = styled.span`
  flex: 1;
`;
